import React from "react";
import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import { palette, withMediaQueries } from "@stedi/dls/constants";
import { NextRouter, useRouter } from "next/router";
import { NoScript } from "../components/NoScript";
import { Playground } from "../components/Playground";
import { sampleJsonataExpression, sampleSource } from "../lib/samples";

const SMain = styled.main({
  backgroundColor: palette.gray6,
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

function EmbedPage() {
  const router = useRouter();
  const { expressionPanelHeight, outputPanelHeight, sourcePanelHeight } = getHeightVariables(router);

  const isLazy = parseBooleanQueryParam(router.query["lazy"]);

  const styles = css(
    withMediaQueries({
      body: {
        overflowX: "auto",
      },
      ":root": {
        "--layout": "column",
      },
    }),
  );

  return (
    <>
      <Global styles={styles} />
      <SMain>
        <Playground
          defaultExpression={sampleJsonataExpression}
          defaultSource={sampleSource}
          expressionPanelHeight={expressionPanelHeight}
          isEmbedded={true}
          isLazy={isLazy}
          isResizable={false}
          outputPanelHeight={outputPanelHeight}
          sourcePanelHeight={sourcePanelHeight}
        />
        <NoScript />
      </SMain>
    </>
  );
}

export default EmbedPage;

const getHeightVariables = (router: NextRouter) => {
  if (!router.isReady) {
    return {
      sourcePanelHeight: undefined,
      expressionPanelHeight: undefined,
      outputPanelHeight: undefined,
    };
  }

  return {
    sourcePanelHeight: parseNumericQueryParam(router.query["sourcePanelHeight"]),
    expressionPanelHeight: parseNumericQueryParam(router.query["expressionPanelHeight"]),
    outputPanelHeight: parseNumericQueryParam(router.query["outputPanelHeight"]),
  };
};

const parseNumericQueryParam = (param: string | string[] | undefined): number | undefined => {
  if (typeof param === "string") {
    return parseInt(param, 10);
  }

  if (Array.isArray(param)) {
    return parseNumericQueryParam(param[0]);
  }

  return undefined;
};

const parseBooleanQueryParam = (param: string | string[] | undefined): boolean => {
  if (typeof param === "string") {
    return param === "true";
  }

  if (Array.isArray(param)) {
    return parseBooleanQueryParam(param[0]);
  }

  return false;
};
